/**
 * 登录用户类型
 */

import { AccountType, AdPlatformTypeName, Agency } from './agency';
import { Role } from './role';

// 登录账号类型
export enum LoginNameType {
  qq = 1,                                         // qq号
  wx = 12,                                        // 微信openid
  free = 0,                                       // 免登录
}

// 登录类型
export enum LoginType {
  qq = 1,                                         // sso选qq号
  wx = 2,                                         // sso选微信号
  free = 3,                                       // 商管免登录
  mock = 4,                                       // 模拟登录
  api = 5,                                        // api调用登录
  apiMock = 6,                                    // api模拟免登录
  freeRole = 8,                                   // 模拟任意角色免登录
}

// 员工类型
export enum OperatorType {
  inner = 1,
  outer = 2,
  sub = 3, // 子账号员工，其他都认为是一代员工
}

// 权限类型
export interface Privilege {
  privilege_id: number;                           // 权限id
  privilege_name: string;                         // 权限名称
}

// 网站地图类型
export interface SiteMap {
  navMenu: object[];                              // 菜单导航
  redirectUrl: string;                            // 重定向地址
  routes: object[];                               // 路由
  pathTabNavMap: Record<string, object[]>;        // 二级导航
  pathSubNavMap: Record<string, object[]>;        // 三级导航
}

// 用户销售类型
export interface UserSale {
  accountDisplayName: string;
  accountId: number;
  agencyId: number;
  agencyName: string;
  authorized: boolean;
  callCenter: string;
  companyId: number;
  grayPermissions: number[];
  loginType: string;
  orderFusion: boolean;
  redirectOA: string;
  tokenPermissions: any[];
  userAvatar: object;
  userDisplayName: string;
  userId: number;
  userLoginName: string;
  userLoginType: string;
  userPermissions: number[];
  userQqNumber: string;
  userRoles: any[];
}

// 用户类型
export interface User {
  agency_list: Agency[];                          // 服务商列表
  total_agency_list: Agency[];                    // 服务商列表(包含封停账号)
  agency_name: string;                            // 服务商名称
  agency_uid: number;                             // 服务商id
  bm_id: number;                                  // 主体服务商id
  bm_name: string;                                // 主体服务商名称
  company_id: number;                             // 公司id
  feature_flag_list: Record<number, Record<string, number>>; // feature开关列表
  feature_flag: Record<string, number>;           // feature开关，针对bm_id
  knowledge_token: string;                        // 知识库需要校验的凭证
  login_name_type: LoginNameType;                 // 登录账号类型
  login_type: LoginType;                          // 登录类型
  need_update_wechat_number: 0 | 1;               // 是否需要更新微信号
  operator_name: string;                          // 操作者名称
  operator_type: OperatorType;                    // 员工类型
  portal_url: string;                             // 融合门户的iframe引入URL
  privilege_list: Record<number, Privilege>;      // 权限列表
  qq_avatar: string;                              // QQ头像
  qq_nickname: string;                            // QQ昵称
  qq_number: number;                              // QQ号
  rbac_token: string;                             // ORBAC系统的iframe引入URL
  rbac_url: string;                               // ORBAC系统的iframe引入Token
  role_list: Record<number, Role>;                // 角色列表
  sale_agency_uid: number;                        // 销售
  user_id: number;                                // 用户id
  wechat_avatar: string;                          // 微信头像
  wechat_nickname: string;                        // 微信昵称
  wechat_number: string;                          // 微信号
  wechat_openid: string;                          // 微信号openid
  saleStatus: UserSale;                           // 销售信息
  hasSaleRole: boolean;                           // 有销售角色
  env: string;                                    // 当前后端环境
  privilege: number[];                            // 权限数组
  account_type: AccountType;                      // cs账号类型
  hasPlatform: Record<AdPlatformTypeName, boolean>; // 是否包含平台
  agency_list_map: Record<number, Agency>;        // 服务商列表字典
  real_name_verify_status: 1 | 0;                 // 实名认证状态
  taskTeamEnable: boolean | null;                 // 是否有任务团队权限
  featureFlagInitDone: boolean;                   // 灰度开关是否完全加载
  siteMap: SiteMap;                               // 网站地图
  oneOf: (perm: number | number[]) => boolean;    // 任意一个权限通过
  allOf: (perm: number | number[]) => boolean;    // 所以权限满足通过
}
